/**
 * Fibonacci placement interaction, co-located with the tool (Phase 5). The
 * two-anchor placement / drag / preview only — the rich per-fib menu (levels
 * editor, hide-diagonal, label side) stays in Chart.tsx since it's coupled to
 * dialog state. Fib's renderer + settings already live under their own modules.
 */
import type { FibRetracement } from "@/state/slices/uiSlice";
import type { DragTarget } from "@/components/Chart/types";

type Point = { time: number; price: number };

export function buildFib(a: Point, b: Point): FibRetracement {
  return {
    id: `fib_${Date.now()}`,
    startTime: a.time,
    startPrice: a.price,
    endTime: b.time,
    endPrice: b.price,
  };
}

export function fibPreview(anchor: Point, hover: Point): FibRetracement {
  return {
    id: "preview",
    startTime: anchor.time,
    startPrice: anchor.price,
    endTime: hover.time,
    endPrice: hover.price,
  };
}

export function fibDragPartial(
  drag: Extract<DragTarget, { type: "fib"; anchor: "start" | "end" }>,
  time: number | null,
  price: number | null,
): Partial<Omit<FibRetracement, "id">> | null {
  const partial: Partial<Omit<FibRetracement, "id">> = {};
  if (time != null) {
    if (drag.anchor === "start") partial.startTime = time;
    else partial.endTime = time;
  }
  if (price != null) {
    if (drag.anchor === "start") partial.startPrice = price;
    else partial.endPrice = price;
  }
  return Object.keys(partial).length > 0 ? partial : null;
}
